import { getApiUrl, API_ENDPOINTS } from '../config/api';
import { ApiError } from './errors';

const DEFAULT_OPTIONS = {
  headers: { 'Content-Type': 'application/json' },
  credentials: 'include',
};

export const adminService = {
  async getThreads(limit = 30, cursor = null) {
    const url = new URL(getApiUrl(API_ENDPOINTS.admin.threads));
    url.searchParams.set('limit', String(limit));
    if (cursor) url.searchParams.set('cursor', cursor);

    const response = await fetch(url.toString(), { ...DEFAULT_OPTIONS, method: 'GET' });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const message =
        errorData.detail ||
        errorData.message ||
        `HTTP error! status: ${response.status}`;
      throw new ApiError(message, {
        status: response.status,
        code: errorData.code,
        raw: errorData,
      });
    }

    return response.json();
  },

  async getThreadDetail(threadId, includeMetadata = false) {
    const url = new URL(getApiUrl(API_ENDPOINTS.admin.threadDetail(threadId)));
    if (includeMetadata) url.searchParams.set('include_metadata', 'true');

    const response = await fetch(url.toString(), { ...DEFAULT_OPTIONS, method: 'GET' });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const message =
        errorData.detail ||
        errorData.message ||
        `HTTP error! status: ${response.status}`;
      throw new ApiError(message, {
        status: response.status,
        code: errorData.code,
        raw: errorData,
      });
    }

    return response.json();
  },

  async exportThread(threadId, includeMetadata = false) {
    const url = new URL(getApiUrl(API_ENDPOINTS.admin.threadExport(threadId)));
    if (includeMetadata) url.searchParams.set('include_metadata', 'true');

    const response = await fetch(url.toString(), { ...DEFAULT_OPTIONS, method: 'GET' });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const message =
        errorData.detail ||
        errorData.message ||
        `HTTP error! status: ${response.status}`;
      throw new ApiError(message, {
        status: response.status,
        code: errorData.code,
        raw: errorData,
      });
    }

    return response.json();
  },

  async getProposals(state = null, limit = 50, offset = 0) {
    const url = new URL(getApiUrl(API_ENDPOINTS.admin.proposals));
    url.searchParams.set('limit', String(limit));
    url.searchParams.set('offset', String(offset));
    if (state) url.searchParams.set('state', state);

    const response = await fetch(url.toString(), { ...DEFAULT_OPTIONS, method: 'GET' });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const message =
        errorData.detail ||
        errorData.message ||
        `HTTP error! status: ${response.status}`;
      throw new ApiError(message, {
        status: response.status,
        code: errorData.code,
        raw: errorData,
      });
    }

    return response.json();
  },

  async confirmProposal(proposalId, confirmedSlot, sendNotificationTo = null) {
    const url = getApiUrl(API_ENDPOINTS.admin.confirmProposal(proposalId));
    const body = { confirmed_slot: confirmedSlot };
    if (sendNotificationTo) body.send_notification_to = sendNotificationTo;

    const response = await fetch(url.toString(), {
      ...DEFAULT_OPTIONS,
      method: 'POST',
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const message =
        errorData.detail ||
        errorData.message ||
        `HTTP error! status: ${response.status}`;
      throw new ApiError(message, {
        status: response.status,
        code: errorData.code,
        raw: errorData,
      });
    }

    return response.json();
  },

  async declineProposal(proposalId) {
    const url = getApiUrl(API_ENDPOINTS.admin.declineProposal(proposalId));

    const response = await fetch(url.toString(), {
      ...DEFAULT_OPTIONS,
      method: 'POST',
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const message =
        errorData.detail ||
        errorData.message ||
        `HTTP error! status: ${response.status}`;
      throw new ApiError(message, {
        status: response.status,
        code: errorData.code,
        raw: errorData,
      });
    }

    return response.json();
  },
};
